import get from 'lodash.get';
import filter from 'lodash.filter';

export default class ConditionReportSection {
  constructor(conditionReportSection) {
    this.section = conditionReportSection;
  }

  get questions() {
    return get(this.section, 'questions', []);
  }

  get sectionName() {
    return get(this.section, 'section_name');
  }

  get numberQuestionsAnsweredYes() {
    return filter(this.questions, { selected: true }).length;
  }
}
